<template>
  <div class="fff">
    <div class="tab">
      <div :class="isshow == 0 ? 'tab_li mr' : 'tab_li'" @click="changeShow(0)">
        {{$t('gps.list')}}
        <div></div>
      </div>
      <div :class="isshow == 1 ? 'tab_li mr' : 'tab_li'" @click="changeShow(1)">
        {{$t('gps.map')}}
        <div></div>
      </div>
    </div>
    <div class="LIist" v-show="isshow == 0">
      <div class="timeAll_w">
        <el-date-picker
          v-model="value1"
          class="timeAll"
          type="daterange"
          @change="getlist"
          disabled
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-dropdown disabled @command="handleCommand" class="timeDow">
          <span
            class="el-dropdown-link"
            :style="{ color: !isChecked ? '#606266' : '#00eec3' }"
          >
            {{ $t("Last days Days", { days: days })  }}<i
              class="el-icon-caret-bottom el-icon--right"
              :style="{ color: !isChecked ? '#606266' : '#00eec3' }"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="7">{{$t('gps.num1')}}</el-dropdown-item>
            <el-dropdown-item command="30">{{$t('gps.num2')}}</el-dropdown-item>
            <el-dropdown-item command="60">{{$t('gps.num3')}}</el-dropdown-item>
            <el-dropdown-item command="90">{{$t('gps.num4')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <table class="mytable">
        <tr>
          <th>{{$t('gps.latitude')}}</th>
          <th>{{$t('gps.longitude')}}</th>
          <th>{{$t('gps.accuracy')}}</th>
          <th>{{$t('gps.map')}}</th>
          <th>{{$t('gps.address')}}</th>
          <th>{{$t('gps.time')}}</th>
        </tr>
        <tr v-for="(val, key) in list" :key="key">
          <td>{{ val.latitude }}</td>
          <td>{{ val.longitude }}</td>
          <td>{{ val.accuracy }}</td>
          <td>
            <a @click="changeShow(1)" style="cursor:pointer;">{{$t('gps.google')}}</a>
          </td>
          <td class="address">{{ val.address }}</td>
          <td>{{ val.createtime }}</td>
          <!-- <td>{{new Date(val.createtime*1000).toLocaleString().replace(/:\d{1,2}$/,' ')}}</td> -->
        </tr>
      </table>

      <div class="noData" v-if="list.length <= 0 && status">
        {{$t('gps.no')}}
      </div>
      <div class="pagination" v-if="code > 0">
        <el-pagination
          @current-change="setPage"
          background
          layout="prev, pager, next"
          :total="code"
          page-size="20"
        >
        </el-pagination>
      </div>
    </div>
    <div class="Map" v-show="isshow == 1">
      <!-- <div class="google-map" id="map1"></div> -->
      <div class="mapbox-maps">
        <div id="map1" ref="basicMapbox" style="height: 100%;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Gps, getMapKeys } from "@/api/user";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
// eslint-disable-next-line no-unused-vars
const TILE_SIZE = 256;
export default {
  name: "HelloWorld",
  data() {
    return {
      mapInst: "",
      // 组件加载后隐藏
      infowindows: [],
      map: null,
      lat: 40.772072448457735,
      lng: -73.99482299312687,
      days: 7,
      key: {
        equipment_id: localStorage.getItem("systemId"),
        page: 1,
        limit: 20,
        starttime: "",
        endtime: "",
      },
      code: 0,
      value1: "", // 获取时间
      list: [],
      isshow: 0,
      msg: "",
      isChecked: null,
      status: false,
      mapDataCopy: [], // 标记点数据
      currentMarkers: [], //标记点集合
    };
  },
  mounted() {
    let data = [this.lng, this.lat];
    this.mapDataCopy = JSON.parse(JSON.stringify(data));
    this.handleCommand();
  },
  methods: {
    changeShow(index) {
      this.isshow = index;
      if (index == 1) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.map = null;
            this.lat = 44.96882657863069;
            this.lng = -93.2885300219205;
            this.initMap();
          }, 500);
        });
      } else if (index == 0) {
        this.handleCommand();
      }
    },
    // initMap () {
    //   // eslint-disable-next-line no-undef
    //   const mapDiv = new google.maps.Map(document.getElementById('map1'), {
    //     center: {
    //       lat: this.lat,
    //       lng: this.lng
    //     },
    //     zoom: 15,
    //     maxZoom: 20,
    //     minZoom: 3,
    //     streetViewControl: false,
    //     mapTypeControl: false,
    //     disableDefaultUI: false,
    //     zoomControl: false,
    //     scaleControl: false
    //   })
    //   this.map = mapDiv
    //   if (this.list.length > 0) {
    //     this.handLigature()
    //   }
    // },
    async initMap(row) {
      const ddd = await getMapKeys();
      this.list = [
        {
          name: "200 Santa Monica Pier, Santa Monica, CA 90401, United Statess",
          latitude: "34.02686852390601",
          longitude: "-118.49555293439577",
        },
        {
          name: "1200 Getty Center Dr, Los Angeles, CA 90049, United States",
          latitude: "34.1030902710642",
          longitude: "-118.468087116418",
        },
        {
          name:
            "100 Universal City Plaza, Universal City, CA 91608, United States",
          latitude: "34.161063831772466",
          longitude: "-118.35135739001254",
        },
        {
          name: "Los Angeles, CA 90068, United States",
          latitude: "34.1622001707214",
          longitude: "-118.31427853574257",
        },
        {
          name: "2800 E Observatory Rd, Los Angeles, CA 90027, United States",
          latitude: "34.14742657153353",
          longitude: "-118.30191891765256",
        },
        {
          name: "5905 Wilshire Blvd, Los Angeles, CA 90036, United States",
          latitude: "34.08489429490422",
          longitude: "-118.35959713540586",
        },
      ];
      let myIcon = L.icon({
        iconUrl: require("./../assets/img/lastMap.png"),
        iconSize: [27, 40],
        iconAnchor: [15, 32],
      });
      // if (this.list.length <= 0) {
      //   this.list.push({
      //     latitude: this.lat,
      //     longitude: this.lng,
      //   });
      // }
      this.map = L.map("map1", {
        center: [this.list[0].latitude, this.list[0].longitude], // 地图中心
        zoom: 15, //缩放比列
        zoomControl: false, //禁用 + - 按钮
        doubleClickZoom: false, // 禁用双击放大
        attributionControl: false, // 移除右下角leaflet标识
      });
      // styles/
      let name = L.tileLayer(
        // "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        // "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png"
        `https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/256/{z}/{x}/{y}@2x?access_token=${ddd.data.key}`,
        {
          minZoom: 5,
          maxZoom: 18,
        }
      ).addTo(this.map);

      var latlngs = this.list.map((item) => {
        return [item.latitude, item.longitude];
      });

      let polyline = L.polyline(latlngs, { color: "#289329" }).addTo(this.map);
      this.map.fitBounds(polyline.getBounds());

      function marker(list, map, index = 0) {
        console.log(list[index]);
        L.marker([list[index].latitude, list[index].longitude], {
          // title: list[index].name,
          icon: myIcon,
        }).addTo(map);
        if (list.length - 1 > index) {
          marker(list, map, index + 1);
        }
      }
      marker(this.list, this.map);
      //   mapboxgl.accessToken = 'pk.eyJ1Ijoic3B5bGl4MTIzIiwiYSI6ImNsZjF2MnM3NzBjNXAzdGxjcXN2bTNmNmwifQ.2PFuGfj7IrXaWfNDF51_Tw';
      //   const map = new mapboxgl.Map({
      //     container: 'map',
      //     // Choose from Mapbox's core styles, or make your own style with Mapbox Studio
      //     style: 'mapbox://styles/mapbox/streets-v9',
      //     center: [this.lng, this.lat],
      //     zoom: 15
      //   });
      //   let paths = [];
      //   let features = [];
      //   // if(this.list){
      //   //   console.log('存在多个地址');
      //   // }else{
      //   //   this.list.push({
      //   //     longitude:this.lng,
      //   //     latitude:this.lat
      //   //   });
      //   // }
      //   this.list = [];
      //   this.list.push({
      //       longitude:this.lng,
      //       latitude:this.lat
      //     });
      // this.list.map(e=>{
      //   let lng = e.longitude;
      //   let lat = e.latitude;
      //   let arr = [lng,lat];
      //   paths.push(arr);
      //   let item1 = {
      //       type: 'Feature',
      //       geometry: {
      //           type: 'Point',
      //           coordinates: arr
      //       }
      //   }
      //   features.push(item1);
      // })
      // let item2 = {
      //     type: "Feature",
      //     geometry: {
      //         type: 'LineString',
      //         coordinates: paths
      //     }
      // }
      // features.unshift(item2);
      // map.on('load', function () {
      //   map.addSource('l', {
      //       type: 'geojson',
      //       data:{
      //           type: "FeatureCollection",
      //           features: features
      //       }
      //   });
      //   map.addLayer({
      //       id: 'line',
      //       type: 'line',
      //       source: 'l',
      //       layout: {
      //           'line-cap': 'round',
      //           'line-join': 'round',
      //       },
      //       paint: {
      //       "line-width": 5,
      //       "line-opacity":1,
      //       "line-color":"#289329",
      //       }
      //   });
      //   // map.addLayer({
      //   //     "id": "points",
      //   //     "type": "circle",
      //   //     "source": "l",
      //   //     'paint': {
      //   //         'circle-radius': 6,
      //   //         'circle-color': '#F34400'
      //   //     },
      //   // });
      // })
      // paths.map(e=>{
      //    map.on('load', function () {
      //   const marker = new mapboxgl.Marker({
      //     color: "#F13500",
      //     draggable: true
      //     }).setLngLat(e)
      //     .addTo(map);

      //  })
      // })
    },
    handLigature() {
      var polyOptions = {
        strokeColor: "#008000", // 颜色
        strokeOpacity: 2.0, // 透明度
        strokeWeight: 4, // 宽度
      };
      // eslint-disable-next-line no-undef
      const poly = new google.maps.Polyline(polyOptions);
      poly.setMap(this.map); // 装载
      this.list.forEach((el, index) => {
        var path = poly.getPath();
        // eslint-disable-next-line no-undef
        path.push(
          // eslint-disable-next-line no-undef
          new google.maps.LatLng(Number(el.latitude), Number(el.longitude))
        ); // 为线条添加标记坐标
        this.setMarker(Number(el.latitude), Number(el.longitude), el);
      });
    },
    setMarker(lat, lng, el) {
      lat = lat || this.lat;
      lng = lng || this.lng;
      // eslint-disable-next-line no-undef
      const marker = new google.maps.Marker({
        position: {
          lat,
          lng,
        },
        icon: {
          url: "https://api.spylix.com/img/location.png",
          // eslint-disable-next-line no-undef
          scaledSize: new google.maps.Size(50, 50),
        },
        map: this.map,
      });

      // eslint-disable-next-line no-undef
      const latLng = new google.maps.LatLng(lat, lng);

      // eslint-disable-next-line no-undef
      var infowindow = new google.maps.InfoWindow({
        content: `<div style="padding: 10px; max-width: 220px">
          <div style="line-height: 23px;">
            <span>Latitude</span>
            <span style="padding-left: 5px"> ${latLng.lat().toFixed(7)} </span>
          </div>
          <div style="line-height: 23px;">
            <span>Longitude</span>
            <span style="padding-left: 5px"> ${latLng.lng().toFixed(7)} </span>
          </div>
          <div style="line-height: 23px;">
            <span>Date</span>
            <span style="padding-left: 5px">2021-10-12 00:31:30</span>
          </div>
          <div style="line-height: 23px;">
            <span>Accuracy</span>
            <span style="padding-left: 5px"> ${el.accuracy || ""} </span>
          </div>
          <div style="line-height: 23px;">
            <span>Address</span>
            <span style="padding-left: 5px"> ${el.address} </span>
          </div>
        </div>`,
      });

      this.infowindows.push({
        id: el.id,
        infowindow: infowindow,
      });

      // eslint-disable-next-line no-undef
      google.maps.event.addListener(marker, "click", () => {
        this.infowindows.forEach((el) => {
          el.infowindow.close();
        });
        this.$nextTick(() => {
          infowindow.open(this.map, marker);
        });
      });
    },
    handleCommand(event) {
      let end = new Date();
      let start = new Date(2021, 0, 1);
      if (event) {
        this.days = event;
        start = new Date();
        this.isChecked = true;
        start.setTime(start.getTime() - 3600 * 1000 * 24 * event);
      }
      this.value1 = [start, end];
      this.getlist();
    },
    setPage(e) {
      this.key.page = e;
      this.getlist();
    },
    getlist(a) {
      this.status = false;
      this.key.starttime =
        this.value1[0].getFullYear() +
        "-" +
        (this.value1[0].getMonth() < 9 ? "0" : "") +
        (this.value1[0].getMonth() + 1) +
        "-" +
        (this.value1[0].getDate() < 10 ? "0" : "") +
        this.value1[0].getDate();
      this.key.endtime =
        this.value1[1].getFullYear() +
        "-" +
        (this.value1[1].getMonth() < 9 ? "0" : "") +
        (this.value1[1].getMonth() + 1) +
        "-" +
        (this.value1[1].getDate() < 10 ? "0" : "") +
        this.value1[1].getDate();
      if (a) {
        this.key.page = a;
      }
      this.list = [];
      Gps(this.key).then((adj) => {
        this.list = adj.data.list;
        this.code = adj.data.count;
        this.status = true;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://api.tiles.mapbox.com/mapbox-gl-js/v0.44.2/mapbox-gl.css");
.address {
  width: 35%;
  padding: 2px 0;
  text-indent: 0px;
}
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
}
.mytable {
  width: 95%;
}
.mytable a {
  color: #0080ff;
}
.Map {
  width: 100%;
  height: 750px;
  background: #eee;
}
.google-map {
  width: 100%;
  height: 750px;
}
.mapboxgl-map {
  width: 100%;
  height: 750px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.mapboxgl-canvas {
  outline: none;
}
.mapboxgl-ctrl-logo {
  display: none;
}
.mapbox-maps {
  width: 100%;
  height: 750px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/GPS.vue